module.exports = __webpack_public_path__ + "static/img/share_img7.3f870438.png";